<template>
    <div class="card" :id="id + 'Card'">
        <div class="card-header" :id="id + 'Heading'">
            <h2 class="mb-0">
                <button :aria-controls="id + 'Collapse'" :data-target="'#' + id + 'Collapse'" :disabled="disabled" aria-expanded="false" class="btn btn-lg btn-link btn-block text-left collapsed" data-toggle="collapse" type="button">
                    <i v-if="icon" :class="'mr-3 fa fa-' + icon" aria-hidden="true"></i>{{ $t(label) }}
                    <i v-if="completed" class="fa fa-check-circle text-success float-right mt-1"></i>
                </button>
            </h2>
        </div>
        <div :id="id + 'Collapse'" :class="{collapse: true, show: show}" :aria-labelledby="id + 'Heading'" :data-parent="parent">
            <div class="card-body">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CardCollapse",

    props: {
        id: String,
        label: String,
        parent: String,
        icon: String,
        show: {type: Boolean, default: false},
        disabled: {type: Boolean, default: false},
        completed: {type: Boolean, default: false},
    }
}
</script>

<style scoped>

</style>
